import Day from '../includes/Models/Day'
import Swiper from 'react-id-swiper'
import anime from 'animejs'
import date from 'locutus/php/datetime/date'
import Hammer from 'react-hammerjs'

import style from './event_calendar.scss'

import EventCalendarMonth from '../molecules/EventCalendarMonth/EventCalendarMonth.js'
import EventCalendarToday from '../molecules/EventCalendarToday/EventCalendarToday.js'

export default class EventCalendarRender extends React.Component {
  constructor (props) {
    super(props)

    this.handleClickPrev = this.handleClickPrev.bind(this)
    this.handleClickNext = this.handleClickNext.bind(this)

    this.handleSwipe = this.handleSwipe.bind(this)
    this.handleTap = this.handleTap.bind(this)

    this.style_swiper = null
    this.style_list = null
    this.next_item_cnt = 6
  }

  render () {
    var swipeoptions = {
      touchAction:'pan-y',
      recognizers: {
        tap: {
          time: 200,
          threshold: 100
        }
      }
    };

    return (
      <div class="o-eventcalendar__inner">
        <button type="button" class="o-eventcalendar__prev" aria-label="zurück" onClick={this.handleClickPrev}></button>
        <div class="o-eventcalendar__today">
          <EventCalendarToday eventCalendar={this.props.eventCalendar} day={date('Y-m-d',this.props.controller.todaybase)} dayraw={this.props.controller.todaybase} controller={this.props.controller} />
        </div>

        <Hammer onTap={this.handleTap} onSwipe={this.handleSwipe} options={swipeoptions}>
          <div class="o-eventcalendar__swiper" style={this.style_swiper}>
            <ul class="o-eventcalendar" style={this.style_list}>
              {this.props.months.map(month => <li class="o-eventcalendar__trigger">
                <EventCalendarMonth eventCalendar={this.props.eventCalendar} month={month} controller={this.props.controller} /></li>)}
            </ul>
          </div>
        </Hammer>
        <button type="button" class="o-eventcalendar__next" aria-label="vor" onClick={this.handleClickNext}></button>
        <div class="o-eventcalendar__triangle"></div>
      </div>
    )
  }

  componentDidUpdate () {

  }

  set_swiper_css () {
    if (this.props.element.children[0]) {
      this.calender = this.props.element.children[0].children[2].children[0]

      //monate
      let width = 0

      for (let i = 0; i < this.calender.children.length; i++) {
        width += this.calender.children[i].offsetWidth
      }

      if (this.props.controller.calenderbase_width === 0) {
        //set width initial
        this.props.controller.calenderbase_width = width
      }

      //set current width
      this.props.controller.calenderbase_current_width = width * 2

      //set current width to calender list
      this.calender.style.width = width
    }
  }

  handleTap(e) {

  }

  handleSwipe(e) {
    //2 links
    //4 rechts
    if (e.direction === 4) {
      this.handleClickPrev();
    }
    else if (e.direction === 2) {
      this.handleClickNext();
    }
  }

  handleClickPrev () {
    let _this = this

    let items = this.props.controller.get_number_of_max_items()

    //set css
    this.set_swiper_css()

    const offset = parseInt(this.props.controller.offset)

    this.props.controller.calender(offset - this.next_item_cnt, items + this.next_item_cnt).then(() => {
      //set margin -left
      this.set_swiper_css()

      let next_first_element = this.calender.querySelectorAll('.m-eventcalender__month__day')[_this.next_item_cnt]
      this.calender.style.transform = 'translateX(' + (next_first_element.offsetLeft * -1) + 'px)'

      anime({
        targets: this.calender,
        translateX: '-200px',
        easing: 'easeInOutQuad',
        duration: _this.next_item_cnt * 80,
        complete: function (anim) {
          //reset swiper css
          _this.props.controller.calenderbase_width = null
          _this.props.controller.calenderbase_current_width = null
          _this.calender.removeAttribute("style")

          //draw
          //_this.props.controller.calender(offset - _this.next_item_cnt, items)
        }
      })
    })
  }

  handleClickNext () {
    let _this = this

    let items = this.props.controller.get_number_of_max_items()

    //set css
    this.set_swiper_css()

    const offset = parseInt(this.props.controller.offset)

    this.props.controller.calender(offset, items + this.next_item_cnt).then(() => {
      this.set_swiper_css()
      this.forceUpdate()

      let next_first_element = this.calender.querySelectorAll('.m-eventcalender__month__day')[_this.next_item_cnt]
      let margin = parseInt(next_first_element.offsetLeft)

      if (margin > 0) {
        anime({
          targets: this.calender,
          translateX: (margin * -1),
          easing: 'easeInOutQuad',
          duration: _this.next_item_cnt * 80,
          complete: function (anim) {
            //reset swiper css

            _this.props.controller.calenderbase_width = null
            _this.props.controller.calenderbase_current_width = null
            _this.calender.removeAttribute("style")

            const elements = _this.calender.querySelectorAll('.m-eventcalender__month__title');

            if (elements[0]) {
              elements.forEach(function (element) {
                element.removeAttribute("style")
              })
            }

            //draw
            _this.props.controller.calender(offset + _this.next_item_cnt, items)

            //_this.props.controller.sync()
          }
        })
      }
    })
  }
}
